import {AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewChild, ViewContainerRef} from "@angular/core";
import {AppService} from "@api";
import {FiltroModel} from "@componentes/Filtros/Filtro.model";
import {FiltrosComponent} from "@componentes/Filtros/Filtros.component";
import {TipoFiltroEnum} from "@componentes/Filtros/Filtros.enum";
import {RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {TranslateService} from "@ngx-translate/core";
import {SistemaService} from "@servicios/Sistema.Service";
import {PeriodoEvaluacionFormComponent} from "./periodoevaluacionForm.component";
import {PeriodoEvaluacion} from "@modelo/proceso/periodoevaluacion.model";
import {AlertaEnum, DialogoEnum} from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";



@Component({
    selector: 'periodoevaluacion',
    templateUrl: './periodoevaluacion.component.html',
    styleUrls: ['./periodoevaluacion.component.scss']
})


export class PeriodoEvaluacionComponent implements AfterViewInit {
    entidad: PeriodoEvaluacion;
    public errorActivo!: boolean;
    public abierto!: boolean;

    activarcopia: boolean = true;
    dataTable: Array<any>
    selectedRows: any[];
    SelCiclo: any[];
    listtipoevaluacioneliminar: any[];
    vaciarinfo: number = 0;

    consulta!: boolean;
    @ViewChild("periodoevaluacionFormulario", {read: ViewContainerRef}) periodoevaluacionFormulario!: ViewContainerRef;

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string


    constructor(private appService: AppService, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver) {
        this.uriApi = "planeacion/periodoevaluacion/buscar";

        this.entidad = new PeriodoEvaluacion();
        this.selectedRows = [];
        this.SelCiclo = [];
        this.dataTable = [];
        this.listtipoevaluacioneliminar = [];
        this.GenerarFiltros();
    }

    ngAfterViewInit() {
        this.SetCicloFiltro();
    }

    SetDatos(data: any) {
        this.dataTable = data;
    }

    onEditorPreparing(e: any) {
        if (e.dataField === 'selected' && e.parentType === 'dataRow') {
            e.editorOptions = {
                value: false
            }
        }
    }

    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Ciclo',
                    DisplayValor: 'nombre',
                    ValorName: 'cicloid',
                    Opciones: this.SelCiclo,
                    Propiedad: "cicloid",
                    Obligatorio: false,
                    Buscar: false,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.RangoFecha,
                    Titulo: 'Fecha Inicio Periodo',
                    Propiedad: "fechainicioperiodo",
                    Obligatorio: false,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.RangoFecha,
                    Titulo: 'Fecha Inicio Acuerdos',
                    Propiedad: "fechainicioacuerdos",
                    Obligatorio: false,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.RangoFecha,
                    Titulo: 'Fecha Fin Acuerdos',
                    Propiedad: "fechafinacuerdos",
                    Obligatorio: false,
                })
        );

        this.filtrosDisplay = filtrosDisplay;
    }

    SetCicloFiltro() {
        this.appService.Get("catalogo/ciclo").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelCiclo = res.data;
                let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'cicloid');
                if (filtro) {
                    filtro.Opciones = this.SelCiclo;
                }
            }
        });
    }

    Formulario(accionid: number, id: number = 0) {
        let accion: string = ""
        switch (accionid) {
            case 1:
                accion = "Nuevo";
                this.cargarContenedorFormulario({accionid: accionid, accion: accion, id: id});
                break;
            case 2:
                accion = "Ver";
                this.cargarContenedorFormulario({accionid: accionid, accion: accion, id: id});
                break;
            case 3:
                accion = "Editar";
                this.cargarContenedorFormulario({accionid: accionid, accion: accion, id: id});
                break;
        }
    }

    cargarContenedorFormulario(data: {accionid: number, accion: string, id: number}) {
        this.consulta = true;
        this.periodoevaluacionFormulario.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(PeriodoEvaluacionFormComponent);
        var ref: ComponentRef<any> = this.periodoevaluacionFormulario.createComponent(factory);
        ref.instance.accion = {accionid: data.accionid, accion: data.accion};
        ref.instance.id = data.id;
        ref.instance.limpiarcampos = this.vaciarinfo;
        ref.instance.output.subscribe((cambio: boolean) => {
            if (cambio) {
                this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
            }
            this.consulta = false;
            this.vaciarinfo = 0;
            ref.destroy();
        });
    }

    Eliminar(e: PeriodoEvaluacion) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podrá deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("planeacion/periodoevaluacion/" + e.periodoevaluacionid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
                    }
                })
            }
        })
    }

    ValidarGenerarCopia() {
        this.activarcopia = false
    }

    DialogoGuardar(entidad: PeriodoEvaluacion, copia: number) {
        let opciones = this.sistemaService.GetOpcionesConfirmar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Advertencia. <br> Se creará una copia del registro <br>"' + entidad.descripcion + '". <br> ¿Desea Continuar?', opciones).then(res => {
            if (res == 1) {
                this.appService.Post("planeacion/periodoevaluacion/periodoevaluacionportipoevaluacion", {"periodoevaluacionid": entidad.periodoevaluacionid}).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        let periodoevaluacionportipoevaluacion = [];
                        let entidadperiodo = new PeriodoEvaluacion(entidad);
                        if (copia == 1) {
                            entidadperiodo.fechainicioperiodo = this.formatDate(entidadperiodo.fechainicioperiodo)
                            entidadperiodo.fechainicioacuerdos = this.formatDate(entidadperiodo.fechainicioacuerdos)
                            entidadperiodo.fechafinacuerdos = this.formatDate(entidadperiodo.fechafinacuerdos)
                        }
                        this.vaciarinfo = 1
                        for (let tipoevalua of res.data) {
                            if (tipoevalua.fechainicioevaluacion) {
                                let info = {"fechainicioevaluacion": tipoevalua.fechainicioevaluacion, "preguntaloconoces": tipoevalua.preguntaloconoces, "tipoevaluacionid": tipoevalua.tipoevaluacionid, "periodoevaluacionportipoevaluacionid": tipoevalua.periodoevaluacionportipoevaluacionid}
                                periodoevaluacionportipoevaluacion.push(info)
                            }
                        }
                        let data = {"periodoevaluacion": entidadperiodo, "listeliminar": this.listtipoevaluacioneliminar, "periodoportipo": [], "periodoportipocopia": periodoevaluacionportipoevaluacion}
                        this.appService.Post("planeacion/periodoevaluacion/copia", data).then(res => {
                            if (res.status == RespuestaEstatusEnum.Success) {
                                this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
                                this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                                this.selectedRows = []
                                this.activarcopia = true
                                this.Formulario(3, res.data.id)
                            }
                        })
                    }
                })

            }
        })
    }

    formatDate(date: string) {
        let valor = date.split("/")
        let fecha = valor[2] + "-" + valor[1] + "-" + valor[0];
        return fecha;
    }

    GuardarCopia() {
        if (this.selectedRows.length > 0) {
            this.appService.Post("planeacion/periodoevaluacion/buscar", {"periodoevaluacionid": this.selectedRows[0]}).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    let copiaentidad = new PeriodoEvaluacion(res.data[0]);
                    this.DialogoGuardar(copiaentidad, 1);
                }
            })
        } else {
            this.mensajeService.Alerta(AlertaEnum.Warning, "Se tiene que seleccionar mínimo un periodo de evaluación para realizar una copia");
        }
    }

    GuardarCopiaUltimo() {
        this.appService.Get("planeacion/periodoevaluacion/ultimoperiodoevaluacion").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                if (res.data == 0) {
                    this.mensajeService.Alerta(AlertaEnum.Warning, "No se encuentra ningun periodo de evaluación");
                    this.Formulario(1);
                } else {
                    let copiaentidad = new PeriodoEvaluacion(res.data);
                    copiaentidad.cicloid = res.data.cicloid["cicloid"];
                    this.DialogoGuardar(copiaentidad, 2);
                }
            }
        })
    }

}